import { render, staticRenderFns } from "./gc-dashboard-customer-balances-card.vue?vue&type=template&id=4aee4c70&scoped=true"
import script from "./gc-dashboard-customer-balances-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-customer-balances-card.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-customer-balances-card.vue?vue&type=style&index=0&id=4aee4c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aee4c70",
  null
  
)

export default component.exports